import React from "react";
import Routes from "./pages/config/Routes";

const App = () => {
    return <Routes />;
};

export default App;